module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AN-3586f9dac3f532740f31ab6ff5b002be.png";